import type { BadgeAsset } from '../models/image/dto/badge-asset';
import type { VariantBadge } from '../models/product/dto/variant-badge';

export class PrintCardBadgeRowUtils {
  /**
   * Product badges keep their existing order and theme cap; list terpene badges are appended after them.
   * Terpene badges that duplicate a product badge image are dropped so a shared badge never renders twice.
   * The optional cap applies after de-duplication so dropped duplicates never consume a terpene slot.
   */
  static appendListTerpeneBadges(
    productBadges: VariantBadge[],
    listTerpeneBadges: BadgeAsset[],
    maxListTerpeneBadges?: number
  ): BadgeAsset[] {
    const productBadgeAssets = productBadges?.map(productBadge => productBadge?.image) ?? [];
    const productBadgeAssetIds = productBadgeAssets.map(asset => asset?.id).filterNulls();
    const terpeneBadgeAssets = listTerpeneBadges?.filter(asset => !productBadgeAssetIds.includes(asset?.id)) ?? [];
    const cappedTerpeneBadgeAssets = terpeneBadgeAssets.slice(0, maxListTerpeneBadges ?? terpeneBadgeAssets.length);
    return [...productBadgeAssets, ...cappedTerpeneBadgeAssets];
  }
}
